// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import Dropzone from "react-dropzone";

import { Classes, MPDButton, MPDIcon } from "src/mpd-library";

import { HTMLDivProps } from "@blueprintjs/core";

import "./styles.css";

export interface IMultiMediaDropInActiveProps extends HTMLDivProps {
  multiMedia: any;
  onMultiMediaStateChange(event: any, type: string): void;
  onMultiMediaOnDrop(files: any, id: string): void;
  onRecordAudio?(event: any, type: string): void;
}

export const MultiMediaDropInActive: React.SFC<
  IMultiMediaDropInActiveProps
> = props => {
  const { multiMedia, onMultiMediaOnDrop, onRecordAudio } = props;

  const { fileTypes, fileName, state, voice } = multiMedia;
  const classes = classNames(
    "multimedia-drop-inactive",
    fileName === null && voice.state === null && Classes.ACTIVE
  );

  return (
    <div className={classes}>
      <Dropzone
        accept={fileTypes}
        className="dropzone"
        activeClassName="multimedia-dropzone-active"
        rejectClassName="multimedia-dropzone-reject"
        onDrop={e => onMultiMediaOnDrop(e, state)}
      >
        <div className="dropzone-content">
          <MPDIcon name="clo-cloud-upload" />
          <h3>DRAG &amp; DROP FILES TO UPLOAD</h3>
          <h6> or </h6>
          <MPDButton text="Upload File" />
        </div>
      </Dropzone>
      <div
        className={classNames(
          "footer-button",
          state === "audio" && Classes.ACTIVE
        )}
      >
        <MPDButton
          text={"Record Audio In Browser"}
          onClick={(e: any) => onRecordAudio && onRecordAudio(e, "init")}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/components/multimedia/multimedia-drop-inactive.tsx